/*
 * Import the Bootstrap components individually.
 */

require('bootstrap/js/dropdown');
require('bootstrap/js/modal');
require('bootstrap/js/tooltip');
